import moment from "moment/moment";

export function formatDuration(milliseconds) {
    let duration = moment.duration(milliseconds);
    let minutes = duration.asMinutes();
    if (minutes < 1) {
        return ' 0 min';
    } else if (minutes < 60) {
        return moment.utc(duration.asMilliseconds()).format("m[min]");
    } else if (minutes < 60 * 24) {
        return  moment.utc(duration.asMilliseconds()).format("H[h]m[m]");
    } else {
        return  moment.utc(duration.asMilliseconds()).format("D[d]H[h]");
    }
}
